import React, { useEffect, useState } from "react";
import "./HeroInputAnimation.css";
import { useNavigate } from "react-router-dom";

const HeroInputAnimation = () => {
    const [typedEmail, setTypedEmail] = useState("");
    const [score, setScore] = useState(0);
    const [showBadge, setShowBadge] = useState(false);
    const emailToType = "user@example.com";
    const finalScore = Math.floor(Math.random() * 20) + 80; // 80–99

    let navigate = useNavigate();
    const routeChange = () =>{
        let path = '/register';
        navigate(path);
    }

    useEffect(() => {
        // Typing simulation
        const typeInterval = setInterval(() => {
            setTypedEmail((prev) => {
                const next = emailToType.slice(0, prev.length + 1);
                if (next === emailToType) clearInterval(typeInterval);
                return next;
            });
        }, 100);

        return () => clearInterval(typeInterval);
    }, []);

    useEffect(() => {
        if (typedEmail === emailToType) {
            // Start score animation
            let current = 0;
            const scoreInterval = setInterval(() => {
                current++;
                setScore(current);
                if (current >= finalScore) {
                    clearInterval(scoreInterval);
                    setTimeout(() => setShowBadge(true), 500);
                }
            }, 20);

            return () => clearInterval(scoreInterval);
        }
    }, [typedEmail]);

    const ScoreBadge = ({ score }) => (
        <div className="score-badge">
            Score {score}
        </div>
    );

    const DeliverableBadge = () => (
        <div className="deliverable-badge">
            <span className="icon">✔</span> Deliverable
        </div>
    );

    return (
        <div className="hero-cta">
            <div className="hero-input-group">
                <input
                    type="text"
                    className="hero-input"
                    value={typedEmail}
                    readOnly
                />

                {typedEmail === emailToType && (
                    <div className="hero-result-wrapper">
                    <ScoreBadge score={score} />
                        {showBadge && <DeliverableBadge />}
                    </div>
                )}
            </div>

            <button onClick={routeChange} className="hero-button">GET STARTED FREE →</button>
        </div>
    );
};

export default HeroInputAnimation;